/**
 * Cart page behavior (sections/cart.liquid).
 *
 * Quantity steppers, quantity inputs and remove links update the cart through
 * the Cart AJAX API, then re-render the section via the Section Rendering API
 * so line totals, the subtotal and the free-shipping progress all stay in sync.
 * The header count and the drawer are refreshed through SgCart.
 *
 * Everything is delegated from `document`, so the re-rendered markup needs no
 * re-binding. Without JS the plain form post (`updates[]` + Update button)
 * still works.
 */
(function () {
  var NOTE_DEBOUNCE = 600;
  var noteTimer;

  function root() {
    return document.querySelector('[data-cart-page]');
  }

  function init() {
    var page = root();
    if (!page) return;

    // The Update button only exists for the no-JS path.
    var update = page.querySelector('[data-cart-update]');
    if (update) update.hidden = true;
  }

  function setBusy(line) {
    var page = root();
    if (!page) return;
    var row = page.querySelector('[data-cart-line="' + line + '"]');
    if (row) row.setAttribute('aria-busy', 'true');
  }

  function changeLine(line, quantity) {
    setBusy(line);

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart change failed');
        return response.json();
      })
      .then(refreshSection)
      .then(syncDrawer)
      .catch(function (error) {
        console.error('SgCartPage: update failed', error);
        // Fall back to a reload so the customer never sees a stale cart.
        window.location.reload();
      });
  }

  function updateNote(value) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: value })
    }).catch(function (error) {
      console.error('SgCartPage: note update failed', error);
    });
  }

  function refreshSection() {
    var page = root();
    if (!page) return Promise.resolve();

    var sectionId = page.dataset.sectionId;

    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId))
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-cart-page]');
        var current = root();
        if (!fresh || !current) {
          window.location.reload();
          return;
        }
        current.replaceWith(fresh);
        init();
      });
  }

  function syncDrawer() {
    if (window.SgCart && typeof window.SgCart.fetch === 'function') {
      window.SgCart.fetch();
    }
  }

  function lineOf(element) {
    var row = element.closest('[data-cart-line]');
    return row ? parseInt(row.dataset.cartLine, 10) : null;
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-cart-page]')) return;

    var stepper = event.target.closest('[data-cart-qty]');
    if (stepper) {
      var input = stepper.parentElement.querySelector('[data-cart-qty-input]');
      var step = stepper.dataset.cartQty === 'plus' ? 1 : -1;
      var next = (parseInt(input.value, 10) || 0) + step;
      changeLine(lineOf(stepper), next);
      return;
    }

    var remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      event.preventDefault();
      changeLine(lineOf(remove), 0);
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-qty-input]');
    if (!input || !input.closest('[data-cart-page]')) return;
    changeLine(lineOf(input), parseInt(input.value, 10) || 0);
  });

  document.addEventListener('input', function (event) {
    var note = event.target.closest('#cart-note');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      updateNote(note.value);
    }, NOTE_DEBOUNCE);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
